"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useUpdateCache = exports.updateCache = void 0;
var client_1 = require("@apollo/client");
var deepmerge_1 = __importDefault(require("deepmerge"));
function merge(a, b) {
    // deepmerge doesnt accept `DeepPartial` even though it supports it.
    return (0, deepmerge_1.default)(a, b, {
        // Replace arrays rather than concatenate.
        arrayMerge: function (_, sourceArray) { return sourceArray; },
    });
}
function update(_a) {
    var cache = _a.cache, document = _a.document, variables = _a.variables, newData = _a.newData;
    var oldData = cache.readQuery({
        query: document,
        variables: variables,
    });
    if (oldData) {
        cache.writeQuery({
            query: document,
            variables: variables,
            data: merge(oldData, newData),
        });
    }
}
function updateCache(props) {
    return function (cache) { return update(__assign({ cache: cache }, props)); };
}
exports.updateCache = updateCache;
function useUpdateCache(props) {
    var cache = (0, client_1.useApolloClient)();
    return {
        updateCache: function (newData) {
            return update(__assign(__assign({ cache: cache }, props), { newData: newData }));
        },
    };
}
exports.useUpdateCache = useUpdateCache;
